import { Box } from "@mui/material";
import './SectionSpinner.css';

const SectionSpinner = ({ source = '' }) => (
  <Box
    sx={{
      position: source === "AccessRequestForm" || source === "SupportTicketDialog" ? "fixed" : "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(255,255,255,0.4)",
      backdropFilter: "blur(2px)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: source === "AccessRequestForm" || source === "SupportTicketDialog" ? 2000 : 10,
      borderRadius: "4px",
    }}
  >
    {/* Dotted loader */}
    <span className="dotted-spinner"></span>
  </Box>
);

export default SectionSpinner;